<template>
  <div class="programmirovanie-reviews">
    <div class="v2-container-small programmirovanie-reviews__head">
      <h2 class="title-secondary">
        Отзывы наших учеников
      </h2>

      <div class="no-tablet">
        <button
          class="m-btn"
          @click="prevSlide"
        >
          <img
            loading="lazy"
            src="/v2/catalog/programmirovanie/slider-button.svg"
            alt="prev"
          >
        </button>
        <button
          class="m-btn rotate-180"
          @click="nextSlide"
        >
          <img
            loading="lazy"
            src="/v2/catalog/programmirovanie/slider-button.svg"
            alt="next"
          >
        </button>
      </div>
    </div>

    <custom-scroll-slider
      ref="slider"
      :items="slides"
      :container-width="1240"
      :gap="20"
    >
      <template #item="{ slide: review }">
        <div class="programmirovanie-reviews__slide">
          <div>
            <img
              :src="`/v2/catalog/programmirovanie/reviews/${review.image}.png`"
              :alt="review.name"
            >
            <b>{{ review.name }}</b>
          </div>
          <p v-html="review.review" />
          <span>{{ review.date }}</span>
        </div>
      </template>
    </custom-scroll-slider>
  </div>
</template>

<script>
import CustomScrollSlider from '../../common/CustomScrollSlider.vue';

export default {
  name: 'ProgrammirovanieReviews',
  components: { CustomScrollSlider },
  data: () => ({
    slides: [
      {
        image: '1',
        name: 'I am Violetta',
        // eslint-disable-next-line max-len,vue/max-len
        review: 'Все круто! 😄👍 Очень интересная программа, отзывчивый преподаватель – отвечал на любой вопрос. качество проведения вебинаров на высшем уровне',
        date: '17.03.2023',
      },
      {
        image: '2',
        name: 'WyBcoz',
        review: 'Крутой курс по стримингу) Особенно понравилось выполнять дз',
        date: '05.05.2023',
      },
      {
        image: '3',
        name: 'Игорь Чернецов',
        // eslint-disable-next-line max-len,vue/max-len
        review: 'Все понравилось, особенно создание своей игры. Всегда бы такие домашки были )) преподаватели класс) понравились примеры от него. сразу все понятно)',
        date: '14.02.2023',
      },
      {
        image: '4',
        name: 'Nikto',
        // eslint-disable-next-line max-len,vue/max-len
        review: 'Все&nbsp;было хорошо, лично мне&nbsp;очень понравилось, сам&nbsp;курс, домашки. Если&nbsp;возникают проблемы или&nbsp;появляются вопросы, преподаватель и&nbsp;куратор помогают. Вебинары тоже&nbsp;суперские, объясняют все&nbsp;просто и&nbsp;понятно.',
        date: '14.02.2023',
      },
      {
        image: '5',
        name: 'Сашка',
        review: 'Курс по phython хороший, впечатления - во! Ожидания от обучения – огромные)',
        date: '10.04.2023',
      },
      {
        image: '6',
        name: 'falling|into|darkness',
        // eslint-disable-next-line max-len,vue/max-len
        review: 'Курс интересный, преподаватель прекрасный, отзывчивый. Но по времени курс немного неудобный. На час вперед было бы отлично.',
        date: '29.02.2023',
      },
      {
        image: '7',
        name: 'ruslan shemin',
        // eslint-disable-next-line max-len,vue/max-len
        review: 'Преподаватель классный, уроки смотреть интересно. хорошо и понятно все объясняет, приводит пимеры, и темы классные каждый урок что-то новое пробую делать. круто)',
        date: '09.09.2023',
      },
      {
        image: '8',
        name: 'янескажу',
        // eslint-disable-next-line max-len,vue/max-len
        review: 'Нравится осознание того, что&nbsp;я&nbsp;уже, хоть&nbsp;и&nbsp;на&nbsp;примитивном уровне и&nbsp;ничего такого в&nbsp;этом нет, могу сделать сайт. Когда я&nbsp;его просматриваю, смотрю код&nbsp;— чувствую, что&nbsp;я&nbsp;собой доволен. Преподаватель очень хорошо объясняет и&nbsp;доносит мысль. Да&nbsp;и&nbsp;всегда классно учиться чему‑то новому',
        date: '16.07.2023',
      },
      {
        image: '9',
        name: 'иРиночка',
        // eslint-disable-next-line max-len,vue/max-len
        review: 'Думала, что&nbsp;ничего в&nbsp;этом не&nbsp;пойму. 😅 спасибо преподавателю за&nbsp;такое классное обучение в&nbsp;языке программирования на&nbsp;питоне',
        date: '01.08.2023',
      },
      {
        image: '10',
        name: 'юлечка eley',
        // eslint-disable-next-line max-len,vue/max-len
        review: 'Огромное впечатление произвёл преподаватель, который общался с&nbsp;нами как&nbsp;с&nbsp;товарищами, легко находил общий язык с&nbsp;учениками и&nbsp;мог&nbsp;заинтересовать каждого, и&nbsp;помочь в&nbsp;необходимом случае. Подача материала так-же порадовала 😊',
        date: '10.04.2023',
      },
    ],
  }),
  methods: {
    nextSlide() {
      this.$refs.slider.nextSlide();
    },
    prevSlide() {
      this.$refs.slider.prevSlide();
    },
  },
};
</script>

<style scoped lang="scss">

.programmirovanie-reviews {
  &__head {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 60px;

    @include media-down(tablet) {
      margin-bottom: 32px;
    }

    h2 {
      letter-spacing: -0.03em;

      @include media-down(tablet) {
        letter-spacing: -0.02em;
      }
    }

    div {
      display: flex;
      gap: 12px;
    }

    button {
      line-height: 0;
    }
  }

  .custom-slider {
    padding-bottom: 20px;
    margin-bottom: -20px;
  }

  &__slide {
    width: 435px;
    min-height: 400px;
    padding: 30px;

    display: flex;
    flex-direction: column;
    gap: 20px;

    background-image: url("/v2/catalog/programmirovanie/reviews/bg.svg");
    background-size: 100% 100%;
    filter: drop-shadow(4px 4px 20px rgba(7, 21, 57, 0.05));

    @include media-down(tablet) {
      width: 310px;
      padding: 30px 8px;
      background-image: url("/v2/catalog/programmirovanie/reviews/bg-mob.svg");
      background-size: 100% 100%;
    }

    div {
      position: relative;
      display: flex;
      gap: 12px;
      align-items: center;

      img {
        width: 44px;
        height: 44px;
      }

      b {
        font-weight: 500;
        font-size: 24px;
        line-height: 90%;
        letter-spacing: -0.02em;
        color: $grey2;
      }
    }

    p {
      position: relative;
      font-weight: 500;
      font-size: 18px;
      line-height: 130%;
      letter-spacing: -0.01em;
      font-feature-settings: 'pnum' on, 'lnum' on;
      color: $black;
    }

    span {
      position: relative;
      font-weight: 500;
      font-size: 18px;
      line-height: 130%;
      letter-spacing: -0.01em;
      font-feature-settings: 'pnum' on, 'lnum' on;
      color: $grey2;
      opacity: 0.6;
    }
  }

  @include media-down(tablet) {
    .custom-slide:nth-of-type(8) .programmirovanie-reviews__slide {
      min-height: 430px;
      background-image: url("/v2/catalog/programmirovanie/reviews/bg-mob-long.svg");
    }
  }
}

</style>
